import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getMaintenanceFull } from '../Api'

export default generateApiAction({
  baseType: Types.MAINTENANCES.GET.FULL,
  api: getMaintenanceFull,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/maintenances/GetFullAction.js